// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MTCxQ","wrapper":"Footer_wrapper__B81uX","top":"Footer_top__ykpOD","text":"Footer_text__Gamn6"};